/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { Biller } from './Biller';
import type { ChargeCache } from './ChargeCache';

export type BillCacheAdmin = {
    type?: BillCacheAdmin.type | null;
    from_entity?: any;
    to_entity?: any;
    generate_integration_bill?: boolean;
    readonly charge_caches?: Array<ChargeCache>;
    readonly biller?: Biller;
}

export namespace BillCacheAdmin {

    export enum type {
        PATIENT = 'patient',
        INSURANCE = 'insurance',
        INTRACOMPANY = 'intracompany',
        EXTERNAL = 'external',
        CLIENT = 'client',
        PURCHASE = 'purchase',
        TEST = 'test',
        UNKNOWN = 'unknown',
    }


}
